import UrlSearchParamKey from '../../../utils/url-search-params/url-search-params';

interface ISsoLinkParams {
  ssoUrl: string;
  postLoginDestinationNotUrlEncoded?: string;
  selectedLanguage: string;
  shouldSaveAsUsersPermanentLanguage: boolean;
}

export const addOrReplaceSsoLinkParams = ({
  ssoUrl,
  postLoginDestinationNotUrlEncoded,
  selectedLanguage,
  shouldSaveAsUsersPermanentLanguage,
}: ISsoLinkParams) => {
  const ssoUrlObject = new URL(ssoUrl);
  if (postLoginDestinationNotUrlEncoded) {
    ssoUrlObject.searchParams.delete(
      UrlSearchParamKey.BACKEND_POST_LOGIN_REDIRECT_TO,
    );
    ssoUrlObject.searchParams.set(
      UrlSearchParamKey.BACKEND_POST_LOGIN_REDIRECT_TO,
      postLoginDestinationNotUrlEncoded,
    );
  }
  // This param is consumed by our SSO provider, not us, so
  // to avoid confusion, it's not in UrlSearchParamKey:
  ssoUrlObject.searchParams.delete('ce_lang');
  ssoUrlObject.searchParams.set('ce_lang', selectedLanguage);
  if (shouldSaveAsUsersPermanentLanguage) {
    // 'lang' tells the SSO provider what language to display as, so
    // always must be provided.
    // If 'save-lang' is set, 'lang' also gets set as the user's preferred
    // language in our database, overwriting any existing preference.
    // (We don't always want to save the language, e.g. in the case where
    // a Spanish user clicks an email link that takes them to a page requiring
    // login, and so is immediately redirected to the SSO provider. In that case,
    // English will be the lang param because it is default, and we don't want to
    // save English as the user's new language because they never actually selected
    // it.)
    ssoUrlObject.searchParams.delete('ce_save_lang');
    ssoUrlObject.searchParams.set('ce_save_lang', 'true');
  }
  return ssoUrlObject.toString();
};
